import * as THREE from 'three'

export default class CurvedPlaneGeometry extends THREE.PlaneGeometry {
  type = 'CurvedPlaneGeometry'

  constructor (points, width = 1, segments = 12) {
    super(1, 1, 1, segments)

    const curve = new THREE.SplineCurve(points)

    this.length = curve.getLength()
    this.width = width

    curve.getSpacedPoints(segments).forEach((point, i) => {
      const position = new THREE.Vector3(point.x, point.y, 0)

      const tangent = curve.getTangentAt(i / segments)
      const normal = new THREE.Vector3(-tangent.y / 2, tangent.x / 2, 0)
      const offset = normal.normalize().multiplyScalar(width / 2)

      this.vertices[2 * i].copy(position).add(offset)
      this.vertices[2 * i + 1].copy(position).add(offset.negate())
    })
  }
}
